// Loads all pillar guide JSON files from src/data/guides/ at build time.

export type GuideFaq = { q: string; a: string };
export type GuideTocItem = { id: string; label: string };
export type GuideSatellite = { slug: string; title: string; summary?: string };

export type Guide = {
  slug: string;
  serviceSlug: string; // links to /servicios/[slug]
  serviceTitle: string;
  title: string;
  summary: string;
  date: string;
  updatedDate?: string;
  readingTime: number;
  authorId?: string;
  seoTitle?: string;
  seoDescription?: string;
  keywords?: string[];
  tldr?: string;
  toc: GuideTocItem[];
  body: string;
  faqs?: GuideFaq[];
  satellites?: GuideSatellite[];
};

const modules = import.meta.glob<Guide>("./guides/*.json", {
  eager: true,
  import: "default",
});

export const GUIDES: Guide[] = Object.values(modules).sort(
  (a, b) => +new Date(b.date) - +new Date(a.date),
);

export const GUIDES_BY_SLUG: Record<string, Guide> = GUIDES.reduce(
  (acc, g) => {
    acc[g.slug] = g;
    return acc;
  },
  {} as Record<string, Guide>,
);

export const getGuideBySlug = (slug?: string): Guide | undefined =>
  slug ? GUIDES_BY_SLUG[slug] : undefined;
